import React from 'react';
import { useConfiguration } from '../../context/configurationContext';
import { required, requiredFieldArrayCheckbox } from '../../util/validators';
import { FieldSelect, FieldCheckbox, FieldCheckboxGroup } from '../../components';

import css from './MultiAssetFocus.module.css';

const MultiAssetFocus = (props) => {
    const config = useConfiguration();

    const { values, intl } = props;
    const { mainFocus = [] } = values || {};

    const categories = config.categoryConfiguration.categories;
    const listingFields = config.listing.listingFields;

    const hasSelectedEstate = mainFocus.includes("comm_re") || mainFocus.includes("resi_re");

    return <div className={css.root}>
        <FieldSelect
            className={css.extraInput}
            id="primaryAssetClass"
            name="primaryAssetClass"
            label={intl.formatMessage({
                id: 'ProfileSettingsForm.primaryAssetClass',
            })}
            validate={required("Required")}
        >
            <option value="">Select one</option>
            {categories.map(c => <option key={c.id} value={c.id}>
                {c.name}
            </option>)}
        </FieldSelect>

        <legend className={css.label}>
            Areas of focus:
        </legend>
        {categories.map(cat => {
            const { id, name, subcategories } = cat;
            const isChecked = mainFocus.includes(id);
            const applicableFields = listingFields.filter(f =>
                f.categoryConfig.limitToCategoryIds &&
                f.categoryConfig.categoryIds?.includes(id)
            );

            const hasSubCategories = subcategories.length > 0;
            const hasFields = applicableFields.length > 0;

            const showNestedOptions = isChecked
                && (hasSubCategories || hasFields)

            const subCategoriesAndAllOption = [
                {
                    key: "any",
                    label: "All",
                },
                ...subcategories.map(sc => {
                    return {
                        key: sc.id,
                        label: sc.name,
                    }
                }),
            ];

            return <div key={id} className={css.item}>
                <FieldCheckbox
                    id={id}
                    name="mainFocus"
                    label={name}
                    value={id}
                    validate={required("Required")}
                />

                {showNestedOptions ? <div className={css.subItem}>
                    {hasSubCategories ? <FieldCheckboxGroup
                        id={`detailedFocus.${id}.subCategory`}
                        name={`detailedFocus.${id}.subCategory`}
                        label="Sub category"
                        options={subCategoriesAndAllOption}
                        // validate={requiredFieldArrayCheckbox("Required")}
                    /> : null}

                    {hasFields ? <div className={css.fields}>
                        {applicableFields.map(field => {
                            const { key, saveConfig, enumOptions } = field;
                            return <FieldCheckboxGroup
                                key={`detailedFocus.${id}.fields.${key}`}
                                id={`detailedFocus.${id}.fields.${key}`}
                                name={`detailedFocus.${id}.fields.${key}`}
                                label={saveConfig.label}
                                options={enumOptions.map(sc => {
                                    return {
                                        key: sc.option,
                                        label: sc.label,
                                    }
                                })}
                                validate={requiredFieldArrayCheckbox("Required")}
                            />
                        })}
                    </div> : null}
                </div> : null}
            </div>
        })}

        {hasSelectedEstate ? <div className={css.extraEstateQuestions}>
            <FieldSelect
                id="estateQ1"
                name="estateQ1"
                label="Would you like to be notified of the Real Estate investment opportunities presented by Parnexus members?"
                validate={required("Required")}
            >
                <option disabled value="">
                    Select one
                </option>
                <option value="yes">
                    Yes
                </option>
                <option value="no">
                    No
                </option>
            </FieldSelect>

            <FieldSelect
                id="estateQ2"
                name="estateQ2"
                label="Would you like to offer your Real Estate investment opportunities to other Parnexus members?"
                validate={required("Required")}
            >
                <option disabled value="">
                    Select one
                </option>
                <option value="yes">
                    Yes
                </option>
                <option value="no">
                    No
                </option>
            </FieldSelect>
        </div> : null}
    </div>
};

export default MultiAssetFocus;
